<template>
    <div
        class="collapse collapse-arrow rounded md:rounded-md mb-2.5 md:mb-8"
        :class="{'collapse-open': isOpen,'collapse-close': !isOpen}"
    >
        <div
            class="collapse-title text-base xs:text-lg text-white font-bold gradient-primary min-h-[2.5rem] flex items-center pl-3 md:pl-5 pb-0.5 pt-1.5 md:min-h-[3.125rem] relative cursor-pointer rounded-b md:rounded-b-none"
            @click="toggleCollapse"
        >
            {{ serviceData?.transactionItemName }}
        </div>
        <div class="collapse-content bg-white p-0">
            <div class="px-0 pt-2.5 pb-5 md:pt-5 md:pb-7 md:px-5 lg:px-8">
                <slot name="content" />
                <div
                    v-if="isShowButton"
                    class="text-right mt-4"
                >
                    <button
                        v-if="isShowEditButton"
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem]"
                        @click="goBackService()"
                    >
                        返回修改
                    </button>
                    <span
                        v-if="isShowEditButton && isShowRemoveButton"
                        class="mx-2.5 text-gray-400"
                    >/</span>
                    <button
                        v-if="isShowRemoveButton"
                        class="btn-text text-primary border-b border-primary text-[1rem] xs:text-[1.125rem] disabled:text-gray-400 disabled:border-gray-400"
                        @click="removeService()"
                    >
                        刪除變更
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, inject, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import serviceRoutes from '@/json/serviceRoutes';
import aplCatlCode from '@/json/aplCatlCode';
import { editTransactionItem } from '@/apis/system';
import { EUDC } from '@/utils/EUDC';

export default {
    name: 'CollapseConfirmData',
    props: {
        codeId: {
            type: String,
            required: true,
        },
        isShowButton: {
            type: Boolean,
            default: true,
        },
        isShowEditButton: {
            type: Boolean,
            default: true,
        },
        needEUDC: {
            type: Boolean,
            default: true,
        },
        isShowRemoveButton: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const router = useRouter();
        const store = useStore();
        const isOpen = ref(true);
        const aplCatl = inject('aplCatl');
        const visiblePopup = ref(false);
        EUDC(props.needEUDC);
        const toggleCollapse = () => {
            isOpen.value = !isOpen.value;
        };

        // const buttomShow = computed(() => {
        //     let isShow = true;
        //     const hideList = ['IQ'];
        //     if (hideList.includes(props.codeId)) {
        //         isShow = false;
        //     }
        //     return isShow;
        // });

        const serviceData = computed(() => {
            // 在保單的變更項目內
            let item = [];
            if (aplCatl.value !== aplCatlCode.POLICY) {
                // 非保單內的變更項目
                item = store.state.services.serviceList;
            } else {
                const transactionItems = store.state.services.transactionItems;
                item = transactionItems ? transactionItems.filter(i => i.userChecked) : [];
            }
            const data = item.find(i => i.transactionItemNo === props.codeId);

            return data;
        });
        // 返回修改 保單變更才打api
        const goBackService = async () => {
            let canEdit = false;
            if (aplCatl.value === aplCatlCode.POLICY) {
                canEdit = await editTransactionItem(props.codeId).then(res => {
                    if (res.data.status) {
                        return true;
                    }
                });
            } else {
                canEdit = true;
            }
            if (canEdit) {
                store.dispatch('services/setServices', [serviceData.value]);
                // 因應user要求回到指定頁面
                if (serviceData.value) {
                    const goRoute = serviceRoutes.find(i => i.code === props.codeId);
                    router.push({ name: goRoute.editRouteName });
                }
            }
        };
        // 刪除變更
        const removeService = () => {
            emit('removeService');
        };

        return {
            isOpen,
            toggleCollapse,
            removeService,
            goBackService,
            serviceData,
            visiblePopup,
            // buttomShow
        };
    },
};
</script>

<style scoped lang="scss">
.collapse-arrow .collapse-title:after {
    @apply w-[0.875rem] h-[0.875rem];
}

.collapse.collapse-open {
    overflow: hidden;
}

.collapse.collapse-open .collapse-content {
    overflow: hidden;
}
</style>
